import styled from "styled-components";

export const PronunciationTitle = styled.div`
  color: #281045;
  font-size: var(--lg-font-size);
  font-weight: 500;
  padding: 5px 10px;
  border-bottom: 2px solid #ff9e31;
`;

export const PronunciationField = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => (props.align ? props.align : "flex-start")};
  width: ${props => (props.width ? props.width : "18%")};
  padding: 10px 8px;
  font-size: var(--sm-font-size);
  font-weight: 500;
  word-break: break-word;
  color: ${props => (props.primary ? "#ff8a23" : "black")};
  @media (max-width: 1024px) {
    min-width: 120px;
  }
`;

export const TotalCountLabel = styled.span`
  position: absolute;
  left: 15px;
  font-size: var(--xsm-font-size);
  color: rgba(0, 0, 0, 0.5);
`;

export const ActionButton = styled.button`
  border: 1px solid ${props => (props.danger ? "#fc5c65" : "#ff8a23")};
  color: ${props => (props.danger ? "#fc5c65" : "#ff8a23")};
  background: transparent;
  border-radius: 4px;
  font-size: var(--xsm-font-size);
  padding: 4px 12px;
  margin-right: 8px;
  outline: none;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    color: #ffffff;
    background: ${props => (props.danger ? "#fc5c65" : "#ff8a23")};
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalBox = styled.div`
  background: #ffffff;
  border-radius: 6px;
  padding: 28px;
  width: 480px;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalTitle = styled.h3`
  margin: 0 0 20px;
`;

export const FieldLabel = styled.label`
  font-size: var(--xsm-font-size);
  color: #555555;
  margin-bottom: 12px;
  display: block;
`;

export const FieldInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-size: var(--sm-font-size);
  box-sizing: border-box;
  margin-top: 4px;
  background: ${props => (props.readOnly ? "#f5f5f5" : "#ffffff")};
  color: ${props => (props.readOnly ? "#999999" : "inherit")};
`;

export const FieldSelect = styled.select`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-size: var(--sm-font-size);
  box-sizing: border-box;
  margin-top: 4px;
`;

export const PreviewContainer = styled.div`
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 14px;
  margin-bottom: 16px;
`;

export const PreviewTitle = styled.p`
  margin: 0 0 10px;
  font-size: var(--xsm-font-size);
  font-weight: 600;
  color: #432666;
`;

export const PreviewButtonsRow = styled.div`
  display: flex;
  gap: 10px;
`;

export const PreviewButton = styled.button`
  flex: 1;
  padding: 8px;
  border: 1px solid ${props => (props.variant === "success" ? "#5cb85c" : "#432666")};
  border-radius: 4px;
  background: ${props => (props.variant === "success" ? "#5cb85c" : "#432666")};
  color: #ffffff;
  cursor: pointer;
  font-size: var(--xsm-font-size);
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
`;

export const ModalCancelButton = styled.button`
  padding: 8px 18px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  background: #ffffff;
  cursor: pointer;
  font-size: var(--sm-font-size);
`;

export const ModalSaveButton = styled.button`
  padding: 8px 18px;
  border: none;
  border-radius: 4px;
  background: #432666;
  color: #ffffff;
  cursor: pointer;
  font-size: var(--sm-font-size);
`;
